---
de:
  users:
    flash_account_disabled: Das Konto wurde deaktiviert. Kontaktieren Sie den Support.
    flash_account_locked: Das Konto wurde gesperrt. Kontaktieren Sie den Support.
    flash_account_updated: Ihr Konto wurde aktualisiert
    flash_password_reset_instructions: Wir werden Ihnen eine E-Mail senden, insofern wir einen entsprechenden Benutzer-Account finden
    flash_password_sent: Ein neues passwort wurde gesendet an
    form:
      clear_companies_confirm: Dadurch verliert der Benutzer beim Speichern den Zugriff auf alle Unternehmen in dieser Liste.
      clear_power_plants_confirm: Dadurch verliert der Benutzer beim Speichern den Zugriff auf alle Kraftwerke in dieser Liste.
      unlisted_companies: Hat außerdem Zugriff auf ein Unternehmen, das Sie nicht zuweisen können. Es bleibt beim Speichern erhalten. | Hat außerdem Zugriff auf {count} Unternehmen, die Sie nicht zuweisen können. Sie bleiben beim Speichern erhalten.
      unlisted_power_plants: Hat außerdem Zugriff auf ein Kraftwerk, das Sie nicht zuweisen können. Es bleibt beim Speichern erhalten. | Hat außerdem Zugriff auf {count} Kraftwerke, die Sie nicht zuweisen können. Sie bleiben beim Speichern erhalten.
    locales:
      de: DE
      en: EN
      fr: FR
      nb: 'NO'
    password_notice: Lassen Sie das Passwortfeld leer, damit das Passwort unverändert bleibt
    users: Benutzer
